<div class="card modern-card">
  <!-- Header -->
  <div class="card-header border-0 bg-transparent pt-3 px-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        <h1 class="modern-header">
          <i class="fa-solid fa-bell me-2 icon-header"></i>
          Inventory Alerts
        </h1>
      </div>
      <div class="header-actions">
        <button
          type="button"
          class="close-btn"
          (click)="openVendorDashboard()"
          title="Close"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    </div>
  </div>

  <div class="card-body p-4 d-flex flex-column" style="flex: 1; overflow-y: auto;">
    <!-- Active Alerts Header -->
    <div class="action-bar d-flex justify-content-between align-items-center mb-2 bg-dark-subtle p-2 px-3 rounded-3">
      <!-- <h2 class="text-light mb-0" style="font-size: 1.15rem; font-weight: 500;">
        <i class="fa-solid fa-bell me-2" style="color: #00a8ff"></i>
        Wants Alerts
      </h2> -->
      <div class="d-flex gap-2 ms-auto">
        <button
          class="btn red-btn btn-sm shadow-sm"
          (click)="refreshAlertsData()"
          title="Refresh Alerts"
        >
          <i class="fa-solid fa-arrows-rotate"></i> Refresh
        </button>
        <button
          class="btn grey-btn btn-sm shadow-sm"
          (click)="addNewAlertClicked()"
        >
          <i class="fa-solid fa-plus me-2"></i>
          Add New Alert
        </button>
      </div>
    </div>

    <!-- Active Alerts Grid -->
    <div style="flex: 1; min-height: 300px; margin-bottom: 30px;">
      <ag-grid-angular
      #alertGrid
      id="alerts-grid"
      class="modern-grid mb-4"
      style="width: 100%; height: 100%"
      
      [columnDefs]="alertColumnDefs"
      [defaultColDef]="defaultColDef"
      [gridOptions]="gridOptions"
      [rowData]="alertsData"
      (gridReady)="onAlertGridReady($event)"
      [animateRows]="true"
      [rowSelection]="rowSelection"
      [components]="components"
      [preventDefaultOnContextMenu]="true"
      (cellContextMenu)="onCellContextMenu($event)"
    >
    </ag-grid-angular>
    </div>

    <!-- Active Auto-Purchase Header -->
    <!-- <div class="action-bar d-flex justify-content-between align-items-center mb-2 mt-3 bg-dark-subtle p-2 px-3 rounded-3">
      <h2 class="text-dark mb-0" style="font-size: 1.15rem; font-weight: 500;">
        <i class="fa-solid fa-robot me-2" style="color: #00a8ff"></i>
        Active Auto-Purchase
      </h2>
      <div class="d-flex gap-2">
        <button
          class="btn btn-dark btn-sm shadow-sm"
          (click)="refreshAutoPurchasesData()"
          title="Refresh Auto-Purchases"
        >
          <i class="fa-solid fa-arrows-rotate"></i> Refresh
        </button>
        <button
          class="btn btn-dark btn-sm shadow-sm"
          (click)="addNewAutoPurchaseClicked()"
        >
          <i class="fa-solid fa-plus me-2"></i>
          Add New
        </button>
        <button
          class="btn btn-dark btn-sm shadow-sm"
          (click)="openAutoPurchaseHistory()"
        >
          <i class="fa-solid fa-clock-rotate-left me-2"></i>
          History
        </button>
      </div>
    </div> -->

    <!-- Active Auto-Purchase Grid -->
    <!-- <div style="flex: 1; min-height: 300px;">
      <ag-grid-angular
      #autoPurchaseGrid
      id="auto-purchase-grid"
      class="modern-grid"
      style="width: 100%; height: 250px"
      
      [columnDefs]="autoPurchaseColumnDefs"
      [defaultColDef]="defaultColDef"
      [gridOptions]="gridOptions"
      [rowData]="autoPurchaseData"
      (gridReady)="onAutoPurchaseGridReady($event)"
      [animateRows]="true"
      [rowSelection]="rowSelection"
      [components]="components"
      [preventDefaultOnContextMenu]="true"
      (cellContextMenu)="onCellContextMenu($event)"
    >
    </ag-grid-angular>
    </div> -->

  </div>
</div>

<!-- Added for the right click "Copy" function -->
@if ((menuState$ | async)?.showMenu) {
  <div
    class="custom-context-menu"
    [style.top.px]="(menuState$ | async)?.menuTop"
    [style.left.px]="(menuState$ | async)?.menuLeft"
    (mouseenter)="onMenuMouseEnter()"
    (mouseleave)="onMenuMouseLeave()"
  >
    <div (click)="copyCellValue()">
      <i class="fa-solid fa-copy me-2"></i> Copy
    </div>
  </div>
}
